var map = {
	"./Accomplishment.png": 1374,
	"./Calendar-VGL-icon.png": 818,
	"./CollapseFilled.png": 676,
	"./GlobalGivingCausesThumb.png": 1094,
	"./Mistake.png": 1375,
	"./TablePlaceholder.png": 587,
	"./appointments.png": 1376,
	"./calendar.png": 1377,
	"./class-duration-icon.png": 1378,
	"./clients.png": 1379,
	"./dashboard.png": 71,
	"./delete.png": 1380,
	"./event-calendar.png": 1104,
	"./excel-icon.png": 1381,
	"./personal.png": 1382,
	"./reports.png": 1383,
	"./sales.png": 1384,
	"./vector-cover-image.png": 1385,
	"./vectorglobal.png": 1386,
	"./vectorgloballogo.png": 1387,
	"./vg-logo.png": 1096,
	"./vgl-blank-image.png": 1388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1103;